/* eslint-disable */
import React, { useEffect, useState } from "react";
import Select from "react-select";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";

/*------ import url and method ------*/
import * as url from "helper/UrlHelper";
import { getData, putData, uploadMultipleFile } from "utils/Gateway";

import TaskStatusOptions from "data/Prod/TaskStatus.json";
import TaskPriority from "data/Prod/TaskPriority.json";
import { reactSelectStyle } from "Config/Config";
import FileUploadField from "components/Common/FileUploadField/FileUploadField";
import JoditEditorField from "components/Common/JoditEditorField/JoditEditorField";

const UpdateBulkTaskPopup = ({
  taskIds = [],
  afterPopupClose = () => {},
  closePopupHandler = () => {},
  setShowAlert = () => {},
  setAlertMessage = () => {},
  setMessageType = () => {},
}) => {
  const todayValue = new Date().toISOString().split("T")[0];
  const userInfo = JSON.parse(localStorage.getItem("userInfo"));

  const userObj = {
    label: `${userInfo.name ?? userInfo.email} ${userInfo.surname ?? ""}`,
    value: userInfo._id,
    email: userInfo.email,
  };

  /* ------------- Language translation imports starts here ------------- */
  const { t } = useTranslation();

  const token = localStorage.getItem("token");

  const [assignedUserInput, setAssignedUserInput] = useState("");
  const [assignedUserOptions, setAssignedUserOptions] = useState([userObj]);
  const [followersInput, setFollowersInput] = useState("");
  const [followersOptions, setFollowersOptions] = useState([userObj]);
  const [projectInput, setprojectInput] = useState("");
  const [projectListOptions, setprojectListOptions] = useState([]);
  const [sectionInput, setSectionInput] = useState("");
  const [sectionListOptions, setSectionListOptions] = useState([]);

  const [selectedProjectValue, setSelectedProjectValue] = useState(null);
  const [taskProjectId, setTaskProjectId] = useState(null);
  const [sectionValue, setSectionValue] = useState(null);
  const [selectedSectionId, setSelectedSectionId] = useState(null);
  const [title, settitle] = useState("");
  const [details, setDetails] = useState("");
  const [taskStatusValue, settaskStatusValue] = useState(null);
  const [taskStatus, settaskStatus] = useState("");
  const [hours, sethours] = useState("");
  const [price, setPrice] = useState("");
  const [startDate, setstartDate] = useState("");
  const [endDate, setendDate] = useState("");
  const [priorityValue, setpriorityValue] = useState(null);
  const [priority, setpriority] = useState("");
  const [assignedUserValue, setassignedUserValue] = useState(null);
  const [assignedUserId, setassignedUserId] = useState(null);
  const [assignedUserEmail, setAssignedUserEmail] = useState("");
  const [followrsValue, setFollowrsValue] = useState(null);
  const [selectedFollowers, setSelectedFollowers] = useState([]);
  const [rank, setRank] = useState("");
  const [docFileUploading, setDocFileUploading] = useState(false);
  const [uploadedDocFiles, setUploadedDocFiles] = useState([]);
  const [uploadedDocFileIds, setUploadedDocFileIds] = useState([]);
  const [isMilestone, setIsMilestone] = useState(false);

  const [isSaving, setIsSaving] = useState(false);
  const [errorMessage, seterrorMessage] = useState("");

  /* hooks for validation */
  const [errors, setErrors] = useState({});

  // validate =========================
  const validationHandler = () => {
    const newErrors = {};

    // check date compare
    if (startDate !== "" && endDate !== "") {
      const start = new Date(startDate);
      const end = new Date(endDate);
      if (start.getTime() > end.getTime()) {
        newErrors.dateRange = t(
          "The end date cannot be earlier than the start date."
        );
      }
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  //get all projects
  const getProjectList = async () => {
    try {
      let requestUrl =
        url.API_BASE_URL +
        url.API_GET_PROJECTLIST_BY_SEARCH +
        `?token=${token}&searchtitle=${projectInput}`;

      const response = await getData(requestUrl);

      // console.log(response);

      if (response.status) {
        setprojectListOptions(response.data);
      }
    } catch (error) {
      console.log(error);
    }
  };

  //get section list
  const getSectionList = async () => {
    try {
      let requestUrl =
        url.API_BASE_URL +
        url.API_GET_SECTION_LIST_OPTIONS +
        `?token=${token}&projectid=${taskProjectId}&sectiontitle=${sectionInput}`;

      const response = await getData(requestUrl);

      if (response.status) {
        setSectionListOptions(response.data);
      }
    } catch (error) {
      console.log(error.message);
    }
  };

  //function for get assigned user list
  const getAssignedUserList = async () => {
    try {
      let requestUrl =
        url.API_BASE_URL +
        url.API_GET_USERLIST_OPTIONS +
        `?token=${token}` +
        `&userstringinput=${assignedUserInput}`;

      const response = await getData(requestUrl);

      // console.log(response);

      if (response.status) {
        const apiData = response.data.map((item) => ({
          value: item.value,
          label: item.label,
          email: item.email,
        }));

        if (apiData.length === 0) {
          setAssignedUserOptions[userObj];
        }
        if (apiData.some((item) => item.value === userObj.value)) {
          setAssignedUserOptions(apiData);
        } else {
          setAssignedUserOptions([...apiData, userObj]);
        }
      } else {
        setMessageType("error");
        setAlertMessage(response.message);
        setShowAlert(true);
      }
    } catch (error) {
      setMessageType("error");
      setAlertMessage(error.message);
      setShowAlert(true);
    }
  };

  //function for get followers list
  const getFollowersList = async () => {
    try {
      let requestUrl =
        url.API_BASE_URL +
        url.API_GET_USERLIST_OPTIONS +
        `?token=${token}&userstringinput=${followersInput}`;

      const response = await getData(requestUrl);

      if (response.status) {
        const apiData = response.data.map((item) => ({
          value: item.value,
          label: item.label,
          email: item.email,
        }));
        if (apiData.length === 0) {
          setFollowersOptions([userObj]);
        }
        if (apiData.some((item) => item.value === userObj.value)) {
          setFollowersOptions(apiData);
        } else {
          setFollowersOptions([...apiData, userObj]);
        }
      } else {
        setMessageType("error");
        setAlertMessage(response.message);
        setShowAlert(true);
      }
    } catch (error) {
      setMessageType("error");
      setAlertMessage(error.message);
      setShowAlert(true);
    }
  };

  //function for select project
  const projectSelectionHandler = (val) => {
    if (val) {
      setSelectedProjectValue(val);
      setTaskProjectId(val.value);
    } else {
      setSelectedProjectValue(null);
      setTaskProjectId(null);
    }
  };

  //select section
  const sectionSelectionHandler = (val) => {
    if (val) {
      setSectionValue(val);
      setSelectedSectionId(val.value);
      //   setstartDate(val.startdate);
      //   setendDate(val.enddate);
    } else {
      setSectionValue(null);
      setSelectedSectionId(null);
      //   setstartDate("");
      //   setendDate("");
    }
  };

  //select status
  const statusSelectionHandler = (val) => {
    settaskStatusValue(val);

    if (
      val.value === "0" ||
      val.value === "1" ||
      val.value === "2" ||
      val.value === "3"
    ) {
      settaskStatus(val.value);
    }
  };

  //select priority
  const prioritySelectionHandler = (val) => {
    setpriorityValue(val);
    setpriority(val.value);
  };

  //function for get user input
  const assignedUserInputHandler = (val) => {
    setAssignedUserInput(val);
    seterrorMessage("");
  };

  //function for get followers input
  const followersInputHandler = (val) => {
    setFollowersInput(val);
  };

  //select assigned user
  const assignedUserSelectionHandler = (val) => {
    if (val) {
      setassignedUserValue(val);
      setassignedUserId(val.value);
      setAssignedUserEmail(val.email);
    } else {
      setassignedUserValue(null);
      setassignedUserId(null);
      setAssignedUserEmail("");
    }
  };

  //select followers
  const followersSelectionHandler = (val) => {
    setFollowrsValue(val);
    setSelectedFollowers(
      val.map((item) => ({ value: item.value, email: item.email }))
    );
  };

  //function for upload doc files
  const docFileUploadHandler = async (docFiles) => {
    try {
      setDocFileUploading(true);

      let requestUrl =
        url.API_BASE_URL + url.API_MULTIPLE_FILE_UPLOAD + `?token=${token}`;

      const response = await uploadMultipleFile(requestUrl, docFiles);

      if (response.status) {
        /*----- assign uploaded files with path for display start ------*/
        const uploadedFileValues = response.data.map(
          ({ name, path, _id, ...other }) => ({
            name,
            path: url.SERVER_URL + path,
            _id,
          })
        );

        //check old file exist or not if exist then new file will concat with old file
        if (uploadedDocFiles.length == 0) {
          setUploadedDocFiles(uploadedFileValues);
        } else {
          let fileArr = uploadedDocFiles.concat(uploadedFileValues);
          setUploadedDocFiles(fileArr);
        }

        /*----- assign uploaded files with path for display end ------*/
        setDocFileUploading(false);

        /*----- assign uploaded file ids start ------*/
        const fileIds = response.data.map(({ _id, ...other }) => ({ _id }));

        //check old file ids are exist or not.If exist then new id will concat with old id
        if (uploadedDocFileIds.length == 0) {
          setUploadedDocFileIds(fileIds);
        } else {
          let fileArr = uploadedDocFileIds.concat(fileIds);
          setUploadedDocFileIds(fileArr);
        }
        /*----- assign uploaded file ids end ------*/
      } else {
        setMessageType("error");
        setAlertMessage(response.message);
        setShowAlert(true);
      }
      resetDocInput();
    } catch (error) {
      setMessageType("error");
      setAlertMessage(error.message);
      setShowAlert(true);
    }
  };

  //function for delete file from upload stack
  const closeDocFileHandler = (index) => {
    const closedFile = [...uploadedDocFiles];
    const removedFileId = [...uploadedDocFileIds];
    closedFile.splice(index, 1);
    removedFileId.splice(index, 1);
    setUploadedDocFiles(closedFile);
    setUploadedDocFileIds(removedFileId);
    resetDocInput();
  };

  //function for reset doc inputs
  const resetDocInput = () => {
    const file = document.getElementById("uploadedTaskDoc");
    if (file) {
      file.value = null;
    } else {
      return;
    }
  };

  //save bulk tasks
  const saveBulkTaskHandler = async () => {
    if (!validationHandler()) {
      seterrorMessage(t("Please fix the errors in the form."));

      return;
    }

    try {
      let apiData = {
        taskids: taskIds,
      };

      if (title !== "") {
        apiData.title = title;
      }

      if (taskProjectId !== null) {
        apiData.project = taskProjectId;
      }

      if (selectedSectionId !== null) {
        apiData.projectsection = selectedSectionId;
      }

      if (assignedUserId !== null) {
        apiData.assigneduser = assignedUserId;
        apiData.assigneduseremail = assignedUserEmail;
      }

      if (selectedFollowers.length > 0) {
        apiData.followers = selectedFollowers;
      }

      if (details !== "") {
        apiData.description = details;
      }

      if (hours !== "") {
        apiData.hours = hours;
      }

      if (price !== "") {
        apiData.price = price;
      }

      if (priority !== "") {
        apiData.priority = priority;
      }

      if (taskStatus !== "") {
        apiData.completedpercent = taskStatus;
      }

      if (startDate !== "" && endDate !== "") {
        apiData.startdate = startDate;
        apiData.enddate = endDate;
      }

      if (rank !== "") {
        apiData.rank = rank;
      }

      if (uploadedDocFileIds.length > 0) {
        apiData.uploads = uploadedDocFileIds;
      }

      if (isMilestone) {
        apiData.ismilestone = isMilestone;
      }

      setIsSaving(true);

      let requestUrl =
        url.API_BASE_URL + url.API_UPDATE_BULK_TASK + `?token=${token}`;

      const response = await putData(requestUrl, apiData);

      setIsSaving(false);

      if (response.status) {
        setMessageType("success");
        let offCanvasPopup = document.querySelector("#updateBulkTask");
        let offCanvas = bootstrap.Offcanvas.getInstance(offCanvasPopup);
        offCanvas.hide();

        resetHandler();
        afterPopupClose(response.data);
      } else {
        setMessageType("error");
      }

      setAlertMessage(response.message);
    } catch (error) {
      setAlertMessage(error.message);
      setMessageType("error");
    }
    setShowAlert(true);
  };

  //reset function
  const resetHandler = () => {
    setAssignedUserInput("");
    setAssignedUserOptions([userObj]);
    setFollowersInput("");
    setFollowersOptions([userObj]);
    setprojectInput("");
    setprojectListOptions([]);
    setSectionInput("");
    setSectionListOptions([]);
    setSelectedProjectValue(null);
    setTaskProjectId(null);
    setSectionValue(null);
    setSelectedSectionId(null);
    settitle("");
    setDetails("");
    settaskStatusValue(null);
    settaskStatus("");
    sethours("");
    setPrice("");
    setstartDate("");
    setendDate("");
    setpriorityValue(null);
    setpriority("");
    setassignedUserValue(null);
    setassignedUserId(null);
    setAssignedUserEmail("");
    setFollowrsValue(null);
    setSelectedFollowers([]);
    setRank("");
    setUploadedDocFiles([]);
    setUploadedDocFileIds([]);
    setIsMilestone(false);
    setErrors({});
  };

  useEffect(() => {
    if (projectInput.length > 0) {
      getProjectList();
    }
  }, [projectInput]);

  useEffect(() => {
    if (sectionInput.length > 0 && taskProjectId) {
      getSectionList();
    }
  }, [sectionInput, taskProjectId]);

  useEffect(() => {
    if (assignedUserInput.length > 0) {
      getAssignedUserList();
    }
  }, [assignedUserInput]);

  useEffect(() => {
    if (followersInput.length > 0) {
      getFollowersList();
    }
  }, [followersInput]);

  return (
    <div
      className="offcanvas lg offcanvas-end bg-white border-0 shadow-lg"
      tabIndex="-1"
      id="updateBulkTask"
      aria-labelledby="updateBulkTaskLabel"
    >
      {/* Header design similar to SaveFeedbackRulePopup */}
      <div className="offcanvas-header bg-primary text-white p-4 pb-3 border-bottom border-gray-300">
        <div className="d-flex align-items-center gap-3">
          <div className="icon-wrapper p-3 bg-white rounded-circle d-flex align-items-center justify-content-center">
            <span className="material-symbols-outlined text-primary fs-5 icon-md">
              task
            </span>{" "}
            {/* Using 'task' icon */}
          </div>
          <div>
            <h3
              className="offcanvas-title fw-bold text-white mb-0"
              id="offcanvasLabelDetailsLabel"
            >
              {t("Update Bulk Task")}
            </h3>
            <p className="text-white fs-sm mb-0">
              {t("Manage multiple task details at once")}
            </p>
          </div>
        </div>
        <button
          type="button"
          className="btn-close p-2 bg-gray-200 rounded-circle shadow-sm border-0"
          data-bs-dismiss="offcanvas"
          aria-label="Close"
          onClick={() => {
            resetHandler();
            closePopupHandler();
          }}
        ></button>
      </div>
      <div className="offcanvas-body p-4">
        {/* Professional Card Layout */}
        <div className="p-3 p-md-4 border border-gray-300 rounded-10 shadow-sm bg-light">
          <form
            onSubmit={(e) => e.preventDefault()}
            className="d-flex flex-column h-100"
          >
            <div className="fields-container flex-fill">
              {/* Title */}
              <div className="form-group mb-4 p-3 border rounded-8 shadow-sm bg-white">
                <label
                  htmlFor="taskTitle"
                  className="d-block fs-sm fw-semibold mb-2 text-dark"
                >
                  {t("Title")}
                </label>
                <input
                  type="text"
                  id="taskTitle"
                  className="form-control fs-sm shadow-none border border-gray-300"
                  placeholder={t("e.g., Design new homepage mockup")}
                  value={title}
                  onChange={(e) => settitle(e.target.value)}
                />
              </div>

              <div className="form-group mb-4 p-3 border rounded-8 shadow-sm bg-white">
                <div className="row">
                  {/* <!-- ========== Start project Section ========== --> */}

                  <div className="col-md-6 mb-4 mb-md-0">
                    <label
                      htmlFor="status"
                      className="d-block fs-sm fw-semibold mb-2 text-dark"
                    >
                      {t("Select Project")}
                    </label>
                    <Select
                      isClearable
                      styles={reactSelectStyle("3px", "6px", true, false)}
                      placeholder={t("Search by project name...")}
                      options={projectListOptions}
                      value={selectedProjectValue}
                      onChange={(val) => {
                        projectSelectionHandler(val);
                      }}
                      onInputChange={(val) => {
                        setprojectInput(val);
                      }}
                    />
                  </div>

                  {/* <!-- ========== End project Section ========== --> */}

                  {/* <!-- ========== Start Section ========== --> */}

                  <div className="col-md-6">
                    <label
                      htmlFor="section"
                      className="d-block fs-sm fw-semibold mb-2 text-dark"
                    >
                      {t("Section")}
                    </label>
                    <Select
                      isClearable
                      styles={reactSelectStyle("3px", "6px", true, false)}
                      placeholder={t("Search by section name...")}
                      options={sectionListOptions}
                      value={sectionValue}
                      onChange={(val) => {
                        sectionSelectionHandler(val);
                      }}
                      onInputChange={(val) => {
                        setSectionInput(val);
                      }}
                    />
                  </div>

                  {/* <!-- ========== End Section ========== --> */}
                </div>
              </div>

              {/* <!-- ========== Start assigned user,milestone and status Section ========== --> */}
              <div className="form-group mb-4 p-3 border rounded-8 shadow-sm bg-white">
                <div className="row">
                  <div className="col-md-6">
                    <label
                      htmlFor="assignTo"
                      className="d-block fs-sm fw-semibold mb-2 text-dark"
                    >
                      {t("Assigned to")}
                    </label>
                    <Select
                      isClearable
                      styles={reactSelectStyle("3px", "6px", true, false)}
                      placeholder={t("Search by member name or email")}
                      options={assignedUserOptions}
                      value={assignedUserValue}
                      onChange={(val) => {
                        assignedUserSelectionHandler(val);
                      }}
                      onInputChange={(val) => {
                        assignedUserInputHandler(val);
                      }}
                    />
                  </div>
                  <div className="col-md-6">
                    <label
                      htmlFor="assignTo"
                      className="d-block fs-sm fw-semibold mb-2 text-dark"
                    >
                      {t("Followers")}
                    </label>
                    <Select
                      isMulti
                      styles={reactSelectStyle("3px", "6px", true, false)}
                      placeholder={t("Search by member name or email")}
                      options={followersOptions}
                      value={followrsValue}
                      onChange={(val) => {
                        followersSelectionHandler(val);
                      }}
                      onInputChange={(val) => {
                        followersInputHandler(val);
                      }}
                    />
                  </div>
                </div>
              </div>
              {/* <!-- ========== End assigned user and status Section ========== --> */}

              <div className="form-group mb-4 p-3 pb-0 border rounded-8 shadow-sm bg-white">
                <JoditEditorField
                  label={t("Details")}
                  value={details}
                  onChange={(newContent) => setDetails(newContent)}
                  labelClassName="d-block fs-sm fw-semibold mb-2 text-dark"
                />
              </div>

              {/* hours and price */}
              <div className="form-group mb-4 p-3 border rounded-8 shadow-sm bg-white">
                <div className="row">
                  <div className="col-md-6 mb-4 mb-md-0">
                    <label
                      htmlFor="time"
                      className="d-block fs-sm fw-semibold mb-2 text-dark"
                    >
                      {t("Time (Hours)")} *
                    </label>
                    <input
                      type="number"
                      id="time"
                      min={0}
                      className={`form-control fs-sm shadow-none ${
                        errors.hours ? "is-invalid" : "border border-gray-300"
                      }`}
                      placeholder={t("e.g., 8")}
                      value={hours}
                      onChange={(e) => {
                        sethours(e.target.value);
                        if (errors.hours) {
                          setErrors((prev) => ({ ...prev, hours: "" }));
                        }
                        seterrorMessage("");
                      }}
                    />
                    {errors.hours && (
                      <div className="invalid-feedback d-block">
                        {errors.hours}
                      </div>
                    )}
                  </div>
                  <div className="col-md-6">
                    <label
                      htmlFor="price"
                      className="d-block fs-sm fw-semibold mb-2 text-dark"
                    >
                      {t("Price")}
                    </label>
                    <input
                      type="number"
                      min={0}
                      id="price"
                      className="form-control fs-sm shadow-none border border-gray-300"
                      placeholder={t("e.g., 500")}
                      value={price}
                      onChange={(e) => {
                        setPrice(e.target.value);
                      }}
                    />
                  </div>
                </div>
              </div>

              {/* previoues task and priority */}
              <div className="form-group mb-4 p-3 border rounded-8 shadow-sm bg-white">
                <div className="row">
                  <div className="col-md-6">
                    <label
                      htmlFor="priority"
                      className="d-block fs-sm fw-semibold mb-2 text-dark"
                    >
                      {t("Priority")}
                    </label>
                    <Select
                      styles={reactSelectStyle("3px", "6px", true, false)}
                      placeholder={t("Select a priority level")}
                      options={TaskPriority}
                      value={priorityValue}
                      onChange={(val) => {
                        prioritySelectionHandler(val);
                      }}
                    />
                  </div>
                  <div className="col-md-6">
                    <label
                      htmlFor="status"
                      className="d-block fs-sm fw-semibold mb-2 text-dark"
                    >
                      {t("Complete Status")}
                    </label>
                    <Select
                      placeholder={t("Select task status")}
                      styles={reactSelectStyle("3px", "6px", true, false)}
                      options={TaskStatusOptions}
                      value={taskStatusValue}
                      onChange={(val) => {
                        statusSelectionHandler(val);
                      }}
                    />
                  </div>
                </div>
              </div>

              {/* <!-- ========== Start deadline and rank Section ========== --> */}
              <div className="form-group mb-4 p-3 border rounded-8 shadow-sm bg-white">
                <div className="row">
                  <div className="col-md-6 mb-4 mb-md-0">
                    <label
                      htmlFor="deadline"
                      className="d-block fs-sm fw-semibold mb-2 text-dark"
                    >
                      {t("Deadline")}
                    </label>
                    <div className="field-container d-flex flex-column flex-lg-row gap-3 align-items-lg-center rounded-10">
                      <input
                        type="date"
                        id="startdate"
                        className={`form-control fs-sm shadow-none ${
                          errors.startDate
                            ? "is-invalid"
                            : "border border-gray-300"
                        }`}
                        placeholder="Start Date"
                        value={startDate}
                        onChange={(e) => {
                          setstartDate(e.target.value);
                          if (errors.startDate) {
                            setErrors((prev) => ({ ...prev, startDate: "" }));
                          }
                          if (errors.dateRange) {
                            setErrors((prev) => ({ ...prev, dateRange: "" }));
                          }
                          seterrorMessage("");
                        }}
                      />
                      <input
                        type="date"
                        id="enddate"
                        className={`form-control fs-sm shadow-none ${
                          errors.endDate
                            ? "is-invalid"
                            : "border border-gray-300"
                        }`}
                        placeholder="End Date"
                        value={endDate}
                        onChange={(e) => {
                          setendDate(e.target.value);
                          if (errors.endDate) {
                            setErrors((prev) => ({ ...prev, endDate: "" }));
                          }
                          if (errors.dateRange) {
                            setErrors((prev) => ({ ...prev, dateRange: "" }));
                          }
                          seterrorMessage("");
                        }}
                      />
                    </div>
                    {errors.startDate && (
                      <div className="invalid-feedback d-block">
                        {errors.startDate}
                      </div>
                    )}
                    {errors.endDate && (
                      <div className="invalid-feedback d-block">
                        {errors.endDate}
                      </div>
                    )}
                    {errors.dateRange && (
                      <div className="invalid-feedback d-block">
                        {errors.dateRange}
                      </div>
                    )}
                  </div>
                  <div className="col-md-6">
                    <label
                      htmlFor="price"
                      className="d-block fs-sm fw-semibold mb-2 text-dark"
                    >
                      {t("Rank")}
                    </label>
                    <input
                      type="number"
                      min={1}
                      id="price"
                      className="form-control fs-sm shadow-none border border-gray-300"
                      placeholder={t("e.g., 1")}
                      value={rank}
                      onChange={(e) => {
                        setRank(e.target.value);
                      }}
                    />
                  </div>
                </div>
              </div>
              {/* <!-- ========== End deadline and rank Section ========== --> */}

              {/* ------ upload documnet section start ------- */}
              <div className="form-group mb-3 mb-sm-4 p-3 border rounded-8 shadow-sm bg-white">
                <label
                  htmlFor="documents"
                  className="d-block fs-sm fw-semibold mb-2 text-dark"
                >
                  {t("Upload Documents")}
                </label>
                <FileUploadField
                  label={t("Upload Documents")}
                  accept="doc mp4 pdf"
                  onUpload={docFileUploadHandler}
                  files={uploadedDocFiles}
                  onRemove={closeDocFileHandler}
                  loading={docFileUploading}
                  multiple
                  fileType="document"
                />
              </div>
              {/* ------ upload documnet section end ------- */}

              <div className="form-group mb-3 mb-sm-4 p-3 border rounded-8 shadow-sm bg-white">
                <div className="form-check d-flex align-items-center gap-2 fs-sm p-0 m-0">
                  <input
                    className="form-check-input bg-transparent border-2 border-gray-600 shadow-none m-0"
                    type="checkbox"
                    checked={isMilestone}
                    onChange={(e) => {
                      setIsMilestone(e.target.checked);
                    }}
                    id="privateEvent"
                  />
                  <label
                    className="form-check-label fw-semibold text-dark"
                    htmlFor="privateEvent"
                  >
                    {t("Is Milestone")}
                  </label>
                </div>
              </div>
            </div>
            <div className="action d-flex justify-content-end pt-3 border-top mt-auto">
              <button
                onClick={saveBulkTaskHandler}
                type="button"
                className="btn btn-primary d-flex align-items-center gap-2"
                disabled={isSaving}
                style={{
                  cursor: isSaving ? "not-allowed" : "pointer",
                }}
              >
                {isSaving ? (
                  <>
                    <span
                      className="spinner-border spinner-border-sm"
                      role="status"
                      aria-hidden="true"
                    ></span>
                    {t("Saving...")}
                  </>
                ) : (
                  <>
                    <span className="material-symbols-outlined me-1">save</span>{" "}
                    {t("Save Task")}
                  </>
                )}
              </button>
            </div>
            {errorMessage == "" ? null : (
              <div className="error-message">
                <p className="d-flex align-items-center gap-1 text-danger">
                  <span>{errorMessage} !</span>
                </p>
              </div>
            )}
          </form>
        </div>
      </div>
    </div>
  );
};

export default UpdateBulkTaskPopup;
